import { DatePicker } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

const { RangePicker } = DatePicker;

const rangePickerClassName = `custom-range-picker-${Math.random().toString(36).slice(2, 12)}`;

// TODO: Complete the overwriting of the styles
export const RangePickerGlobalStyles = createGlobalStyle`
  .${rangePickerClassName} {
    .ant-picker-cell-inner {
      border-radius: 2px !important;
    }
    .ant-picker-cell-today .ant-picker-cell-inner::before {
      border-color: var(--brand-6) !important;
      border-radius: 2px !important;
    }
    .ant-picker-cell-range-start .ant-picker-cell-inner,
    .ant-picker-cell-range-end .ant-picker-cell-inner  {
      background: var(--brand-6);
      border-radius: 2px !important;
      color: var(--gray-1);
    }
    .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before,
    .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before,
    .ant-picker-cell-in-view.ant-picker-cell-in-range::before {
      background: var(--brand-1) !important;
    }

    .ant-picker-cell .ant-picker-cell-in-view .ant-picker-cell-range-hover {
      background-color: red !important;
    }

  }
`;

export const StyledRangePicker = styled(RangePicker).attrs({
    popupClassName: rangePickerClassName,
})`
    border-radius: 6px;
    width: 100%;

    &.ant-picker-focused {
        border: 1px solid var(--brand-6);
        box-shadow: 0px 0px 4px 0px var(--box-shadow-1);
    }

    &:hover {
        border: 1px solid var(--brand-5);
    }

    &&.ant-btn-primary {
        background-color: red !important;
    }

    &.ant-picker-range > .ant-picker-active-bar {
        background: var(--brand-6);
    }
`;

export const StyledDatePicker = styled(DatePicker)`
    border-radius: 6px;

    &.ant-picker-focused {
        border: 1px solid var(--brand-6);
        box-shadow: 0px 0px 4px 0px var(--box-shadow-1);
    }

    &:hover {
        border: 1px solid var(--brand-5);
    }

    &&.ant-btn-primary {
        background-color: red !important;
    }
`;

export const DatePickerPopupStyle = createGlobalStyle`
  .custom-date-picker-popup .ant-btn-primary {
    border-radius: 6px;
    background-color: var(--brand-6);
    color: var(--gray-1);
    font-size: 14px;
    line-height: 22px;

    &:hover,
    &:focus {
      background-color: var(--brand-5);
      color: var(--gray-1);
                    }
    &:focus {
        outline: 1px solid var(--brand-7);
    }

    &:active {
        background-color: var(--brand-7);
    }

    &:disabled {
        cursor: disabled;
        outline: none;
        border-color: var(--gray-5);
        color: var(--gray-6);
        background-color: var(--gray-3)
    }


  }
`;

export const DatePickerErrorDiv = styled.div`
    color: var(--error-normal);
    font-weight: 400;
    font-size: 14px;
`;
